import React, { useContext, useEffect, useState } from "react";
import partImage from "../../assets/thumb.png";
import settingw from "../../assets/setting-white.svg";
import orderIcon from "../../assets/orderIcon.svg";
import chatico from "../../assets/chat.svg";
import shippingIcon from "../../assets/shippingIcon.svg";
import tickgreen from "../../assets/tick-green.svg";
import tickwhite from "../../assets/tick-white.svg";
import downloadImage from "../../assets/download.svg";
import downloadImageBlue from "../../assets/download.png";
import qualityDocIcon from "../../assets/qc-document.svg";
import consignmentPhotoIcon from "../../assets/dashboard.svg";
import starsIcon from "../../assets/stars.svg";
import starsIconGrey from "../../assets/stars-grey.svg";
import downArrowIcon from "../../assets/downArrow.svg";
import qrCodeIcon from "../../assets/qr-code-icon.svg";
import upArrowIcon from "../../assets/upArrow.svg";
import deleteImageEnabled from "../../assets/blackdelete.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { useIntercom } from "react-use-intercom";
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  Tabs,
  Tab,
  FormControl,
} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import { processType } from "../../utils/constant";
import {
  getOrderByPoRefId,
  handleAcceptPO,
  updateShippingInformation,
  updateDeliveryInformation,
  updateQualityDocsFromSupplier,
  getIssuesForPO,
  updateExpectedShippingDates,
  getDainstaAddress,
  downloadPurchaseOrderPdf,
  getBillsByPoId,
  createBillForPurchaseOrder,
} from "../../utils/actions/userActions";
import fileSaver from "file-saver";
import moment from "moment";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ChatButton from "../../component/Chat/ChatButton";
import Chat from "../../component/Chat/index";
import { ChatRefContext } from "../../context/chatRef.context";
import {
  currencyFormatter,
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
  validateUser,
} from "../../utils/helper";
import backImg from "../../assets/back.svg";
import HoverInfo from "../../component/HoverInfo/HoverInfo";
import CurrencyFormat from "../../component/CurrencyFormat";
import { Loading } from "../../component/Loading";
import editIcon from "../../assets/edit.svg";
import BillDisplayModal from "../../component/BillDisplayModal";
import ConsignmentPhotoViewer from "../../component/ConsignmentPhotoViewer";
import { DeleteIcon, DownloadIcon, EditIcon } from "../../component/icons";

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const OrderDetails = () => {
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  let decode;
  const { setSelectedChatRefId } = useContext(ChatRefContext);
  const [order, setOrder] = useState(null);
  const [expanded, setExpanded] = React.useState(false);
  const [isValidUser, setIsValidUser] = useState(true);
  const { search } = window.location;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [qualityDocObject, setQualityDocObject] = useState({
    name: "",
    file: null,
  });
  const [allIssuesForOrder, setAllIssuesForOrder] = useState([]);
  const [isInvoiceModalVisible, setInvoiceModalVisible] = useState(true);
  const [orderIssue, setOrderIssue] = useState([]);
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [key, setKey] = useState(0);
  // const [showDeliveryTrackingInformation, setShowDeliveryTrackingInformation] =
  //   useState(false);
  // const [isChanged, setIsChanged] = useState({
  //   shippingInfo: false,
  //   deliveryInfo: false,
  // });
  const [showExpectedDateModal, setShowExpectedDateModal] = useState(false);
  const [isAcceptPO, setIsAcceptPO] = useState(false);
  const [expectedShippingDateSelected, setExpectedShippingDateSelected] =
    useState(null);
  const [esdChangeReason, setEsdChangeReason] = useState("");
  const [dainstaAddress, setDainstaAddress] = useState([]);
  const [billsForPurchaseOrder, setBillsForPurchaseOrder] = useState([]);
  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);
  const [billPartsData, setBillPartsData] = useState({});
  const [availableQtyArr, setAvailableQtyArr] = useState({});
  const [billTotalAmount, setBillTotalAmount] = useState(0);
  const [billDocument, setBillDocument] = useState(null);
  const [supplierBillNumber, setSupplierBillNumber] = useState("");
  const [billConsignmentPhotos, setBillConsignmentPhotos] = useState([]);
  const [billQualityDocuments, setBillQualityDocuments] = useState([]);
  const [billShippingDate, setBillShippingDate] = useState(null);
  const [billShippingCarrier, setBillShippingCarrier] = useState("");
  const [billTrackingNumber, setBillTrackingNumber] = useState("");
  const [billToShow, setBillToShow] = useState(null);
  const [isNoConsignments, setIsNoConsignments] = useState(false);
  const [isNoQCDoc, setIsNoQCDoc] = useState(false);
  const [isShowBill, setIsShowBill] = useState(false);
  let userId = localStorage.getItem("_id");
  let email = localStorage.getItem("email");

  useEffect(() => {
    let billForPoArr = [...billsForPurchaseOrder];
    billForPoArr = billForPoArr.filter((item) => !item.isRejected);
    let localAvailableQtyData = {};
    order?.supplierRFQId?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem._id] = lineItem.qty;
    });
    if (billForPoArr.length > 0) {
      billForPoArr.forEach((item) => {
        item?.partsData?.forEach((lineItem) => {
          localAvailableQtyData[lineItem.partItemId] =
            localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
        });
      });
    }

    setAvailableQtyArr(localAvailableQtyData);
  }, [billsForPurchaseOrder]);

  const fetchSecondaryData = async (orderId) => {
    try {
      getBillsByPoId(token, orderId)
        .then((response) => setBillsForPurchaseOrder(response.data))
        .catch((err) => console.log("Error fetching invoices."));
    } catch (error) {
      setLoading(false);
    }
  };

  const handleIssueModalClose = () => {
    setShowIssueModal(false);
  };

  const showDrawer = () => {
    setOpen(true);
    let userId = localStorage.getItem("_id");
    let email = localStorage.getItem("email");
    if (window.location.host === "sc.dainsta.com") {
      window?.dataLayer?.push({
        event: "chatOpen",
        userId: userId,
        chatRefId: order?.pORefId,
        referenceId: email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
      });
    }

    setSelectedChatRefId(order?.pORefId);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedChatRefId(null);
  };

  function isUrlValid(str) {
    str = str ? str : "";
    if (!str.startsWith("http://") && !str.startsWith("https://")) {
      str = "http://" + str;
    }
    var a = document.createElement("a");
    a.href = str;
    return a.host && a.host != window.location.host;
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      const orderResponse = await getOrderByPoRefId(id, token);
      if (orderResponse.status) {
        setOrder(orderResponse.data);
      } else {
        toast.error(
          "Order data not found.Please contact us at info@dainst.com to resolve the issue."
        );
        navigate("/my-orders");
        return;
      }

      fetchSecondaryData(orderResponse.data._id);

      let allIssue = await getIssuesForPO(token);
      let localOrderIssue = [];
      if (allIssue.data.length > 0) {
        allIssue.data.map((item, i) => {
          if (item?.orderId === orderResponse.data._id) {
            localOrderIssue.push(item);
          }
        });
      }

      if (localOrderIssue.length > 0) {
        setAllIssuesForOrder(localOrderIssue);
        setOrderIssue(localOrderIssue[localOrderIssue.length - 1]);
        setKey(localOrderIssue.length - 1);
      }

      const addressData = await getDainstaAddress(token);
      if (addressData.status) {
        setDainstaAddress(addressData.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err1", err);
      toast.error(err.message);
    }
  };

  const handleAcceptPOClick = async () => {
    if (window.location.host === "sc.dainsta.com") {
      window?.dataLayer?.push({
        event: "acceptPurchaseOrder",
        userId: userId,
        purchaseOrderRefId: order?.pORefId,
        referenceId: email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
      });
    }
    setShowExpectedDateModal(true);
    setIsAcceptPO(true);
  };

  const handleDeliveryInformationUpdate = async (e) => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (moment(order.shippedDate).isAfter(moment(e.target.value))) {
        toast.error("Delivery Date cannot be before shipping date.");
        return;
      }

      // if (window.location.host === "sc.dainsta.com") {
      //   window?.dataLayer?.push({
      //     event: "updateDeliveryDate",
      //     userId: userId,
      //     purchaseOrderRefId: order?.pORefId,
      //     billNumber: "TO_BE_IMPLEMENTED",
      //     referenceId: email?.split('@')[0]+ email?.split('@')[1]?.split(".")[0],
      //   });
      // }

      let data = {
        orderId: order._id,
        deliveryDate: e.target.value,
        existingStatus: order.status,
      };

      const updateDeliveryResponse = await updateDeliveryInformation(
        token,
        data
      );
      if (updateDeliveryResponse.data.status) {
        setOrder({
          ...order,
          deliveryDate: updateDeliveryResponse?.data?.data?.deliveryDate,
        });
        toast.success("Delivery date updated successfully");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong while updating delivery information");
    }
  };

  const handleShippingInformationUpdate = async () => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (!order.shippingCarrier || !order.deliveryTrackingLink) {
        toast.error("Shipping Carrier and Tracking Number are required field");
        return;
      }

      let shippingData = {
        shippingCarrier: order.shippingCarrier,
        deliveryTrackingLink: order.deliveryTrackingLink,
        orderId: order._id,
      };

      await updateShippingInformation(token, shippingData);

      toast.success("Shipping information updated successfully");
    } catch (err) {
      console.log("err", err);
      return;
    }
  };

  const handleQualityDocsUpdate = async () => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (!qualityDocObject.name || !qualityDocObject.file) {
        toast.error("Document name and file are required.");
        return;
      }

      let localQualityDoc = [...order.qualityDocuments];
      localQualityDoc.push(qualityDocObject);

      let formData = new FormData();
      localQualityDoc.forEach((val, i) => {
        formData.append("fileToUpload", val.file);
      });
      formData.append("qualityDoc", JSON.stringify(localQualityDoc));
      formData.append("orderId", order._id);

      const qualityDocResponse = await updateQualityDocsFromSupplier(
        token,
        formData
      );

      if (qualityDocResponse.data.status) {
        setOrder({ ...qualityDocResponse.data.data });
        toast.success("Quality document uploaded successfully.");
        setQualityDocObject({ name: null, file: null });
      }
    } catch (err) {
      console.log("err", err);
      return;
    }
  };

  const handleQualityDocsUpload = () => {
    if (!qualityDocObject.name || !qualityDocObject.file) {
      toast.error("Document name and file are required.");
      return;
    }

    if (window.location.host === "sc.dainsta.com") {
      window?.dataLayer?.push({
        event: "uploadQualityDocuments",
        userId: userId,
        purchaseOrderRefId: order?.pORefId,
        billNumber: "",
        referenceId: email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
      });
    }

    setBillQualityDocuments([...billQualityDocuments, qualityDocObject]);
    setQualityDocObject({
      name: "",
      file: null,
    });
  };

  const handleQualityDocumentDelete = (index) => {
    // Create a new array with the item at the specified index removed
    const updatedDocuments = billQualityDocuments.filter((_, i) => i !== index);

    // Update the state with the new array
    setBillQualityDocuments(updatedDocuments);
  };

  const handleConsignmentPhotosUpload = (e) => {
    let filesForCheck = Array.from(e.target.files);
    let isAllFilesValid = true;
    filesForCheck.forEach((file) => {
      if (file.size > 10000000) {
        isAllFilesValid = false;
      }
    });

    if (!isAllFilesValid) {
      toast.error("File size should be less than 10 MB");
      return;
    }

    let files = e.target.files;
    if (window.location.host === "sc.dainsta.com") {
      window?.dataLayer?.push({
        event: "uploadConsignmentPhotos",
        userId: userId,
        purchaseOrderRefId: order?.pORefId,
        billNumber: "",
        referenceId: email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
      });
    }
    setBillConsignmentPhotos([...billConsignmentPhotos, ...files]);
  };

  const handleConsignmentFileDelete = async (index) => {
    let localConsignmentPhotos = [...billConsignmentPhotos];
    localConsignmentPhotos.splice(index, 1);
    setBillConsignmentPhotos([...localConsignmentPhotos]);
  };

  const handleQualityDocDelete = async (index) => {
    let localQualityDocuments = [...order.qualityDocuments];
    localQualityDocuments.splice(index, 1);

    let formData = new FormData();
    localQualityDocuments.forEach((val, i) => {
      formData.append("fileToUpload", val.file);
    });
    formData.append("qualityDoc", JSON.stringify(localQualityDocuments));
    formData.append("orderId", order._id);
    const qualityDocResponse = await updateQualityDocsFromSupplier(
      token,
      formData
    );
    if (qualityDocResponse.data.status) {
      setOrder({ ...qualityDocResponse.data.data });
      toast.success("Quality document deleted successfully.");
    }
  };

  let getFileExtension = (filename) => {
    return filename?.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
  };

  const handleShowSelectedIssue = (key) => {
    setOrderIssue(allIssuesForOrder[key]);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const download = async (name, url) => {
    const data = extractURLAndEncodedFilename(url);
    let fileUrl = `${data.url}/${data.encodedFilename}`;
    fileSaver.saveAs(fileUrl, name);
  };

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      decode = jwt_decode(token);
      if (!decode) {
        navigate("/");
        toast.error("Invalid Token found!");
      } else if (decode) {
        if (decode.userType == "user") {
          let isLoggedInUser = validateUser();
          if (isLoggedInUser) {
            if (id) {
              fetchData();
            }
          }
        } else if (decode.userType == "admin") {
          navigate("/admin");
        } else {
          navigate("/");
        }
      }
    }
  }, []);

  const handleProceedAcceptPOClick = async () => {
    try {
      if (!expectedShippingDateSelected) {
        toast.error("Please selected expected shipping date.");
        return;
      }

      let expectedShippingDateValue = null;
      if (
        !(
          moment(expectedShippingDateSelected).format("DD MMM YYYY") ==
          moment(Date.now())
            .add(order?.supplierRFQId?.leadTime, "days")
            .format("DD MMM YYYY")
        )
      ) {
        if (!esdChangeReason) {
          toast.error(
            "Please enter reason to change the Expected Shipping date."
          );
          return;
        }
        expectedShippingDateValue = expectedShippingDateSelected;
      }

      let data = {
        orderId: order?._id,
        expectedShippingDate: expectedShippingDateValue,
        reasonToChange: esdChangeReason,
      };
      const response = await handleAcceptPO(token, data);
      if (response.data.status) {
        setOrder(response.data.data);
        setIsAcceptPO(false);
        setShowExpectedDateModal(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        toast.success(response.data.message);
      } else {
        toast.error("Something went wrong while accepting PO");
      }
    } catch (err) {
      console.log("err", err.message);
      return;
    }
  };


  const handleClose = () => {
    setShowExpectedDateModal(false);
    setExpectedShippingDateSelected(null);
    setEsdChangeReason("");
  };

  const handleUpdateExpectedShippingDates = async () => {
    try {
      if (!expectedShippingDateSelected) {
        toast.error("Please selected expected shipping date.");
        return;
      }
      if (!esdChangeReason) {
        toast.error(
          "Please enter reason to change the Expected Shipping date."
        );
        return;
      }

      let userId = localStorage.getItem("_id");
      if (window.location.host === "sc.dainsta.com") {
        window?.dataLayer?.push({
          event: "changeESD",
          userId: userId,
          purchaseOrderRefId: order?.pORefId,
          referenceId:
            email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
        });
      }
      let data = {
        expectedShippingDate: expectedShippingDateSelected,
        id: order._id,
        reasonToChange: esdChangeReason,
      };
      const response = await updateExpectedShippingDates(token, data);
      if (response.status) {
        toast.success("Expected Shipping date updated successfully");
        setShowExpectedDateModal(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        setOrder({
          ...order,
          expectedShippingDates: response.data.expectedShippingDates,
        });
      }
    } catch (err) { }
  };

  const handlePODownloadClick = async () => {
    setLoading(true);
    try {
      let userId = localStorage.getItem("_id");
      if (window.location.host === "sc.dainsta.com") {
        window?.dataLayer?.push({
          event: "downloadPurchaseOrder",
          userId: userId,
          purchaseOrderRefId: order?.pORefId,
          referenceId:
            email?.split("@")[0] + email?.split("@")[1]?.split(".")[0],
        });
      }
      let filteredDainstaAddress = dainstaAddress.filter(
        (item) => item.isDefault
      );
      if (filteredDainstaAddress.length == 0) {
        toast.error(
          "Something went wrong. Please contact admin to resolve this issue. Sorry for inconvenience caused."
        );
        return;
      }

      let data = {
        orderId: order?._id,
        dainstaAddress: filteredDainstaAddress[0],
      };

      // await downloadPurchaseOrderPdf(data, token).then((res) => {
      //   fileSaver.saveAs(
      //     `${process.env.REACT_APP_API_ENDPOINT}/public/docs/` +
      //     res?.data?.data,
      //     `${order?.pORefId}.pdf`
      //   );
      // });
      const res = await downloadPurchaseOrderPdf(data, token);
      fileSaver.saveAs(
        `${process.env.REACT_APP_API_ENDPOINT}/public/docs/` + res?.data?.data,
        `${order?.pORefId}.pdf`
      );
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err", err);
      toast.error(err.message);
    }
  };

  const handleCreateNewInvoiceClick = () => {
    let isAllInvoiced = true;
    let availableQtyValuesArr = Object.values(availableQtyArr);
    availableQtyValuesArr.forEach((item) => {
      if (item > 0) {
        isAllInvoiced = false;
      }
    });

    if (!isAllInvoiced) {
      setShowCreateInvoiceModal(true);
    } else {
      toast.error("All items for this order are already invoiced");
    }
  };

  const closeCreateInvoiceModal = () => {
    setShowCreateInvoiceModal(false);
    setBillDocument(null);
    setSupplierBillNumber("");
  };

  const handeBillItemChange = (event, lineId) => {
    let localBillPartsData = { ...billPartsData };
    if (availableQtyArr[lineId] < parseInt(event.target.value)) {
      toast.error(
        "The invoice quantity cannot be more than order item quantity"
      );
      localBillPartsData[lineId] = 0;
    } else {
      localBillPartsData[lineId] = parseInt(event.target.value);
    }

    setBillPartsData(localBillPartsData);
    let localBilTotalAmount = 0;
    order?.supplierRFQId?.partsData.forEach((item) => {
      localBilTotalAmount =
        localBilTotalAmount + (localBillPartsData[item._id] || 0) * item.price;
    });
    setBillTotalAmount(localBilTotalAmount);
  };

  const handleCreateBill = async () => {
    try {
      if (!order?.purchaseOrderNumber) {
        toast.error(
          "Purchase order number is not updated.Please contact admin"
        );
        return;
      }

      if (billTotalAmount <= 0) {
        toast.error(
          "Please enter valid shipping details for parts. Bill amount cannot be zero."
        );
        return;
      }

      if (!billDocument) {
        toast.error("Please upload invoice document");
        return;
      }

      if (!supplierBillNumber) {
        toast.error("Please enter invoice number");
        return;
      }

      if (!billShippingDate) {
        toast.error("Please enter shipping Date.");
        return;
      }

      if (!supplierBillNumber) {
        toast.error("Please enter invoice number");
        return;
      }

      if (!isNoConsignments && billConsignmentPhotos.length == 0) {
        toast.error("Atleast one consignment photo is required");
        return;
      }

      if (!isNoQCDoc && billQualityDocuments.length == 0) {
        toast.error("Atleast one quality document is required");
        return;
      }

      let userResponse = confirm(
        "Are you sure you want to sent this details for approval?"
      );
      if (!userResponse) {
        return;
      }

      let formData = new FormData();
      formData.append("billPartsData", JSON.stringify(billPartsData));
      formData.append("billTotalAmount", billTotalAmount);
      formData.append("supplierBillNumber", supplierBillNumber);
      formData.append("poId", order?._id);
      formData.append("pORefId", order.pORefId);
      formData.append("supplierId", order.supplierId._id);
      formData.append("shippedDate", billShippingDate);
      formData.append("deliveryTrackingLink", billTrackingNumber);
      formData.append("shippingCarrier", billShippingCarrier);
      formData.append("isNoQCDocChecked", isNoQCDoc);
      formData.append("isNoConsignmentsChecked", isNoConsignments);
      formData.append(
        "billQualityDocumentsData",
        JSON.stringify(billQualityDocuments)
      );
      formData.append("billDocument", billDocument);
      billConsignmentPhotos.forEach((photo) => {
        formData.append("billConsigmentPhotos", photo);
      });
      billQualityDocuments.forEach((doc) => {
        formData.append("billQualityDocuments", doc.file);
      });
      setLoading(true);
      const createBillResponse = await createBillForPurchaseOrder(
        token,
        formData
      );

      if (createBillResponse.status) {
        toast.success("Bill created successfully and sent for approval.");
        setShowCreateInvoiceModal(false);
        setBillTotalAmount(0);
        setBillDocument(null);
        setSupplierBillNumber("");
        setBillConsignmentPhotos([]);
        setBillQualityDocuments([]);
        setBillPartsData({});
        let localBillsForPO = [...billsForPurchaseOrder];
        localBillsForPO.push(createBillResponse.data);
        setBillsForPurchaseOrder(localBillsForPO);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error creating", err?.response?.data);
      if (err?.response?.data?.error?.code === 11000) {
        toast.error("Invoice with this bill number already exists");
      } else {
        toast.error(
          err?.response?.data?.message ||
          "Something went wrong  while creating invoice"
        );
      }
    }
  };

  const handleViewDetailsClick = (item) => {
    setBillToShow(item);
    setIsShowBill(true);
  };

  const handleCloseBillDetails = () => {
    // setBillToShow(null)
    setIsShowBill(false);
  };

  const updateBillsForPO = (billData) => {
    let localBillsForPO = [...billsForPurchaseOrder];
    let index = localBillsForPO.findIndex((item) => item._id == billData._id);
    localBillsForPO[index] = billData;
    setBillsForPurchaseOrder(localBillsForPO);
  };

  return (
    <div style={{ width: "100%" }}>
      {isValidUser && !loading ? (
        <>
          <Chat RefId={order?.pORefId} open={open} onDrawerClose={onClose} />

          <BillDisplayModal
            show={isShowBill}
            billData={billToShow}
            supplierRFQData={order?.supplierRFQId}
            handleClose={handleCloseBillDetails}
            updateBillsForPO={updateBillsForPO}
          />

          <Modal
            size="lg"
            dialogClassName="qoute-version-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showIssueModal}
            onHide={handleIssueModalClose}
          >
            <Modal.Header closeButton>
              <Modal.Title
                id="contained-modal-title-vcenter"
                style={{ fontSize: "15px" }}
              >
                Issue Description
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  handleShowSelectedIssue(k);
                }}
                className="mb-3 qoute-version-tabs"
              >
                {allIssuesForOrder.map((item, i) => {
                  return (
                    <Tab eventKey={i} key={i} title={`Issues ${i + 1}`}></Tab>
                  );
                })}
              </Tabs>
              {Object.keys(orderIssue).length > 0 && (
                <div className="issue-div-admin">
                  <div className="issue-col-admin">
                    <h6>Issue Creation Date :</h6>
                    <p> {moment(orderIssue.createdAt).format("DD MMM YYYY")}</p>
                    <h6>Parts with Issue : </h6>
                    {orderIssue?.partsWithIssue?.length > 0 ? (
                      orderIssue.partsWithIssue.map((orderIssueIn, i) => {
                        return orderIssueIn?.selectedPartFile?.originalname ? (
                          <p
                            className="downloadables"
                            style={{ fontSize: "13px" }}
                            key={i}
                            onClick={(e) => {
                              let extension = getFileExtension(
                                orderIssueIn.selectedPartFile?.originalname
                              );
                              let url = `${process.env.REACT_APP_API_ENDPOINT}/${orderIssueIn?.selectedPartFile?.path}`;
                              download(
                                orderIssueIn.selectedPartFile.originalname,
                                url
                              );
                            }}
                          >
                            {orderIssueIn?.selectedPartFile?.originalname}
                            <img src={downloadImage} />
                          </p>
                        ) : (
                          <p key={i}>
                            (No file uploaded) Item description :{" "}
                            {orderIssueIn.description}{" "}
                          </p>
                        );
                      })
                    ) : (
                      <p>No parts found</p>
                    )}
                  </div>
                  <div className="issue-col-admin">
                    <h6>Purchase Order Related Issues :</h6>
                    <ul>
                      {orderIssue?.orderRelatedIssue?.length > 0 ? (
                        orderIssue.orderRelatedIssue.map((orderIssue, i) => {
                          return <li key={i}>{orderIssue?.name}</li>;
                        })
                      ) : (
                        <li>No Order related issue</li>
                      )}
                    </ul>
                    <h6>Quality Related Issue :</h6>
                    <ul>
                      {orderIssue?.qualityRelatedIssue?.length > 0 ? (
                        orderIssue.qualityRelatedIssue.map((orderIssue, i) => {
                          return <li key={i}>{orderIssue.name}</li>;
                        })
                      ) : (
                        <li>No Quality related issue</li>
                      )}
                    </ul>

                    <h6>Files attached :</h6>
                    <ul style={{ width: "150px", wordBreak: "break-all" }}>
                      {orderIssue?.issueFileAttachment?.length > 0 ? (
                        orderIssue.issueFileAttachment.map(
                          (fileAttached, i) => {
                            return (
                              <li
                                key={i}
                                onClick={(e) => {
                                  let extension = getFileExtension(
                                    fileAttached.originalname
                                  );
                                  let url = `${process.env.REACT_APP_API_ENDPOINT}/public/uploads/${fileAttached.filename}`;
                                  download(fileAttached.originalname, url);
                                }}
                              >
                                <p
                                  className="downloadables"
                                  style={{ fontSize: "13px" }}
                                >
                                  {fileAttached?.originalname}
                                  <img src={downloadImage} />
                                </p>
                              </li>
                            );
                          }
                        )
                      ) : (
                        <li>No files attached</li>
                      )}
                    </ul>
                  </div>

                  <div className="issue-col-admin">
                    <h6>Is Part Issue : </h6>
                    <p>
                      {orderIssue.isPartIssue
                        ? "It is a part related issue"
                        : "Not a part related issue"}
                    </p>
                    <h6>Issue Description :</h6>
                    <div className="item-description">
                      <p>{orderIssue.issueDescription}</p>
                    </div>
                    <h6>Issue status : </h6>
                    {orderIssue.isIssueClosed ? (
                      <span>
                        <p>Closed</p>
                      </span>
                    ) : (
                      <>
                        <span>
                          <p>Open</p>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleIssueModalClose}>Close</Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            dialogClassName="qoute-version-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showExpectedDateModal}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title
                id="contained-modal-title-vcenter"
                // style={{ fontSize: "15px" }}
                className="font-bold"
              >
                {isAcceptPO
                  ? "Please select the expected shipping date (ESD)"
                  : "Change ESD"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ textAlign: "center" }}>
                <h6 className="font-bold">Select ESD : </h6>
                <FormControl
                  type="date"
                  value={
                    expectedShippingDateSelected
                      ? expectedShippingDateSelected
                      : ""
                  }
                  onChange={(e) =>
                    setExpectedShippingDateSelected(e.target.value)
                  }
                  style={{ width: "300px" }}
                />
                <br />
                {!isAcceptPO ||
                  (expectedShippingDateSelected &&
                    moment(Date.now())
                      .add(order?.supplierRFQId?.leadTime, "days")
                      .format("DD MMM YYYY") !=
                    moment(expectedShippingDateSelected).format(
                      "DD MMM YYYY"
                    )) ? (
                  <>
                    <h6 className="font-bold">Reason to change ESD : </h6>
                    <FormControl
                      type="text"
                      value={esdChangeReason}
                      onChange={(e) => setEsdChangeReason(e.target.value)}
                      placeholder="Enter reason to change ESD (100 character max)"
                      maxLength="100"
                    />
                    {isAcceptPO ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please provide an explanation for the discrepancy
                        between the expected shipping date (
                        {moment(expectedShippingDateSelected).format(
                          "DD MMM YYYY"
                        )}
                        ) and the promised shipping date(
                        {moment(Date.now())
                          .add(order?.supplierRFQId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                        ).
                      </p>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {!isAcceptPO && order?.expectedShippingDates?.length > 0 ? (
                  <>
                    <br />
                    <h6>Expected Shipping Date Record : </h6>
                    <div className="parts-table" style={{ fontSize: "14px" }}>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ fontSize: "12px" }}>Updated On</th>
                            <th style={{ fontSize: "12px" }}>
                              Expected Shipping Date
                            </th>
                            <th style={{ fontSize: "12px" }}>
                              Reason To Change
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {order?.expectedShippingDates?.map((item, index) => {
                            return (
                              <tr key={index} style={{ fontSize: "13px" }}>
                                <td>
                                  {moment(item.updatedDate).format(
                                    "DD MMM YYYY h:mm A"
                                  )}
                                </td>
                                <td>
                                  {moment(item.updateValue).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td>{item.reasonToChange}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="white-btn"
                style={{
                  backgroundColor: "#2b96dc",
                  color: "#fff",
                  border: "1px solid #2b96dc",
                }}
                onClick={() => {
                  if (isAcceptPO) {
                    handleProceedAcceptPOClick();
                  } else {
                    handleUpdateExpectedShippingDates();
                  }
                }}
              >
                Proceed
              </Button>
              <Button
                className="white-btn"
                style={{
                  backgroundColor: "#2b96dc",
                  color: "#fff",
                  border: "1px solid #2b96dc",
                }}
                onClick={handleClose}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="xl"
            aria-labelledby="example-custom-modal-styling-title"
            centered
            show={showCreateInvoiceModal}
            onHide={closeCreateInvoiceModal}
            style={{
              visibility: !isInvoiceModalVisible ? "hidden" : "visible",
              width: "100vw",
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: "15px" }}>
                Enter invoice details
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <div className="table-container">
                  <table style={{ border: "1px solid gray" }}>
                    <thead>
                      <tr>
                        <th className="px-2 text-start">Part Name</th>
                        <th className="px-2 text-start">Description</th>
                        <th className="px-2 text-start">Part Notes</th>
                        <th className="px-2 text-start">Order Qty</th>
                        <th className="px-2 text-start">Available Qty</th>
                        <th className="px-2 text-start">Invoice Qty</th>
                        <th className="px-2 text-start">Unit Price</th>
                        <th className="px-2 text-start">Amount</th>
                      </tr>
                    </thead>
                    <tbody className="invoide-details">
                      {order?.supplierRFQId?.partsData?.length > 0 &&
                        order?.supplierRFQId.partsData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="px-2">
                                <p >
                                  {item?.partName
                                    ? item?.partName
                                    : "Not found"}
                                </p>
                              </td>
                              <td
                                style={{ minWidth: "250px" }}
                                className="px-2"
                              >
                                {order?.supplierRFQId?.selectedProcess >= 3 ? (
                                  <>{item?.description}</>
                                ) : (
                                  <>
                                    <ul
                                      style={{
                                        listStyle: "none",
                                        padding: 0,
                                        marginTop: 0,
                                      }}
                                    >
                                      {item?.description}
                                      {item?.materialType ? (
                                        <li>
                                          {item?.materialType}{" "}
                                          {item?.subMaterial
                                            ? ", " + item?.subMaterial
                                            : ""}
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                    </ul>
                                  </>
                                )}
                              </td>
                              <td>
                                <p className="amt">{item?.partNotes}</p>
                              </td>
                              <td>
                                <p style={{ textAlign: "center" }}>
                                  {item?.qty}
                                </p>
                              </td>

                              <td>
                                <p style={{ textAlign: "center" }}>
                                  {" "}
                                  {availableQtyArr[item._id]}
                                </p>
                              </td>

                              <td style={{ textAlign: "center" }}>
                                <p>
                                  <input
                                    className="p-1 mx-2 border"
                                    type="number"
                                    value={billPartsData[item._id]}
                                    onWheel={numberInputOnWheelPreventChange}
                                    placeholder="Invoice Qty"
                                    onChange={(e) =>
                                      handeBillItemChange(e, item._id)
                                    }
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    disabled={!availableQtyArr[item._id]}
                                    style={{ minWidth: "60px" }}
                                  />
                                </p>
                              </td>

                              <td>
                                <p className="amt">
                                  {" "}
                                  €{" "}
                                  <CurrencyFormat
                                    amount={Number(item?.price).toFixed(2)}
                                  />
                                </p>
                              </td>

                              <td>
                                <div
                                  className="amt"
                                  style={{ minWidth: "60px" }}
                                >
                                  <p className="un-fld">
                                    €{" "}
                                    <CurrencyFormat
                                      amount={Number(
                                        (billPartsData[item._id] || 0) *
                                        item.price
                                      )}
                                    />
                                  </p>
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                      <tr className="heading-row">
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col" className="mb-2">
                          <p className="un-fld">
                            Total Amount
                          </p>
                        </td>
                        <td scope="col">
                          <p className="un-fld">
                            €{" "}
                            <CurrencyFormat
                              amount={Number(billTotalAmount).toFixed(2)}
                            />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="bill-form-container">
                  <div className="bill-form-row">
                    <div>
                      <label htmlFor="invoice-number">Enter Invoice Number:</label>
                      <Form.Control
                        id="invoice-number"
                        type="text"
                        value={supplierBillNumber}
                        placeholder="Enter Invoice Number"
                        onChange={(e) => setSupplierBillNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billShippingDate">
                        Enter Shipping Date:
                      </label>
                      <Form.Control
                        id="billShippingDate"
                        type="date"
                        value={billShippingDate}
                        placeholder="Enter shipping date"
                        onChange={(e) => {
                          if (window.location.host === "sc.dainsta.com") {
                            window?.dataLayer?.push({
                              event: "updateShippingInformation",
                              userId: userId,
                              purchaseOrderRefId: order?.pORefId,
                              referenceId:
                                email?.split("@")[0] +
                                email?.split("@")[1]?.split(".")[0],
                            });
                          }
                          setBillShippingDate(e.target.value);
                        }}
                      />
                    </div>

                    <div>
                      <label htmlFor="billShippingCarrier">
                        Enter Shipping Carrier:
                      </label>
                      <Form.Control
                        id="billShippingCarrier"
                        type="text"
                        value={billShippingCarrier}
                        placeholder="Enter shipping carrier"
                        onChange={(e) => setBillShippingCarrier(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billTrackingNumber">
                        Enter Tracking Number:
                      </label>
                      <Form.Control
                        id="billTrackingNumber"
                        type="text"
                        value={billTrackingNumber}
                        placeholder="Enter Tracking Number"
                        onChange={(e) => setBillTrackingNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billDocument">Invoice Document:</label>
                      <br />
                      {billDocument?.name ? (
                        <span className="flex items-center space-x-2">
                          <a
                            className="downloadables inline-flex items-center space-x-1"
                            href={URL.createObjectURL(billDocument)}
                            download={billDocument?.filename}
                            target="_blank"
                            style={{ fontSize: "12px" }}
                          >
                            {billDocument?.name}
                            <DownloadIcon additionalClass="inline-block mx-1 !h-5" />
                          </a>
                          <span
                            className="inline-flex items-center"
                            onClick={() => setBillDocument(null)}
                          >
                            <DeleteIcon additionalClasses="inline-block" />
                          </span>
                        </span>
                      ) : (
                        <>
                          <label
                            className="bill-button"
                            htmlFor={`upload-bill-doc`}
                          >
                            Upload Invoice Document
                          </label>
                          <Form.Control
                            id={`upload-bill-doc`}
                            type="file"
                            style={{ visibility: "hidden" }}
                            onChange={(e) => {
                              let filesForCheck = Array.from(e.target.files);
                              let isAllFilesValid = true;
                              filesForCheck.forEach((file) => {
                                if (file.size > 10000000) {
                                  isAllFilesValid = false;
                                }
                              });

                              if (!isAllFilesValid) {
                                toast.error(
                                  "File size should be less than 10 MB"
                                );
                                return;
                              }
                              setBillDocument(e.target.files[0]);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  <div className="bill-form-container">
                    <div className="h-20 " >
                      <div>
                        <label htmlFor="billDate" className="ms-1 font-bold text-[13px] text-[#858585]" style={{color:""}}>Consignment Photos:</label>
                        <div>
                          <input
                            type="checkbox"
                            checked={isNoConsignments}
                            onChange={() =>
                              setIsNoConsignments(!isNoConsignments)
                            }
                            id="consign-check"
                          />
                          <label
                            htmlFor="consign-check"
                            className="check-label text-red-500 font-bold text-[12px]"
                         
                          >
                            Please check this box to confirm that there are no
                            consignment photos to be uploaded with this
                            invoice.Note that incorrect selection might lead to
                            invoice rejection.
                          </label>
                        </div>

                        {!isNoConsignments && <label
                          className="  border border-gray-400 mt-1 w-40  px-2.5 rounded flex justify-center text-primaryColor"
                          htmlFor={`upload-bill-conginments-photos`}
                        >
                          Upload
                        </label>}
                        {!isNoConsignments && <Form.Control
                          id={`upload-bill-conginments-photos`}
                          type="file"
                          style={{ visibility: "hidden" }}
                          multiple={true}
                          onChange={(e) => {
                            let filesForCheck = Array.from(e.target.files);
                            let isAllFilesValid = true;
                            filesForCheck.forEach((file) => {
                              if (file.size > 10000000) {
                                isAllFilesValid = false;
                              }
                            });

                            if (!isAllFilesValid) {
                              toast.error(
                                "File size should be less than 10 MB"
                              );
                              return;
                            }
                            handleConsignmentPhotosUpload(e);
                          }}
                          accept="image/*"
                        />}
                      </div>
                    </div>

                    {billConsignmentPhotos &&
                      billConsignmentPhotos.length > 0 ? (
                      <div className="">
                        <span>
                          <ConsignmentPhotoViewer
                            parentModalVisibilityFunction={
                              setInvoiceModalVisible
                            }
                            images={billConsignmentPhotos || []}
                            altText={`image`}
                          />
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div className="bill-form-container">
                    <div className="bill-form-row">
                      <div>
                        <label htmlFor="dueDate" className="ms-1">Quality Documents:</label>
                        <div
                          className="col"
                          style={{
                            display: "flex",
                            flexBasis: "45%",
                          }}
                        >
                          <div className="col ">
                            <div style={{ display: "flex" }}>
                              <input
                                type="checkbox"
                                checked={isNoQCDoc}
                                onChange={() => setIsNoQCDoc(!isNoQCDoc)}
                                id="quality-check"
                              />
                              <label htmlFor="quality-check"></label>
                              <p className="check-label">
                                Please check this box to confirm that there are
                                no quality document to be uploaded with this
                                invoice.Note that incorrect selection might lead
                                to invoice rejection.
                              </p>
                            </div>
                            {!isNoQCDoc && <label className="ms-1">Document Name:</label>}
                            {!isNoQCDoc && <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              {/* <div className="col   "> */}
                                {/* <div className=" w-[200px] !me-3"> */}
                                  <Form.Control
                                    className="p-1 border h-8  w-full  "
                                    type="text"
                                    name="document-name"
                                    placeholder="Enter document name here"
                                    value={qualityDocObject.name || ""}
                                    // style={{ marginLeft: "-5px" }}/
                                    onChange={(e) =>
                                      setQualityDocObject({
                                        ...qualityDocObject,
                                        name: e.target.value,
                                      })
                                    }
                                  />
                                {/* </div> */}
                              {/* </div> */}
                              <div className="col quality-doc-div-po">
                                {!(
                                  qualityDocObject?.file?.filename ||
                                  qualityDocObject?.file?.name
                                ) &&
                                  qualityDocObject.name && (
                                    <div>
                                      <label
                                        className="bill-button"
                                        htmlFor={`uploadDoc`}
                                      >
                                        Upload
                                      </label>
                                      <Form.Control
                                        id={`uploadDoc`}
                                        className="quality-doc-item-input"
                                        type="file"
                                        onChange={(e) => {
                                          let filesForCheck = Array.from(
                                            e.target.files
                                          );
                                          let isAllFilesValid = true;
                                          filesForCheck.forEach((file) => {
                                            if (file.size > 10000000) {
                                              isAllFilesValid = false;
                                            }
                                          });

                                          if (!isAllFilesValid) {
                                            toast.error(
                                              "File size should be less than 10 MB"
                                            );
                                            return;
                                          }

                                          setQualityDocObject({
                                            ...qualityDocObject,
                                            file: e.target.files[0],
                                          });
                                          const file = e.target.files[0];
                                          if (!qualityDocObject.name || !file) {
                                            toast.error(
                                              "Document name and file are required."
                                            );
                                            return;
                                          }

                                          if (
                                            window.location.host ===
                                            "sc.dainsta.com"
                                          ) {
                                            window?.dataLayer?.push({
                                              event: "uploadQualityDocuments",
                                              userId: userId,
                                              purchaseOrderRefId:
                                                order?.pORefId,
                                              billNumber: "",
                                              referenceId:
                                                email?.split("@")[0] +
                                                email
                                                  ?.split("@")[1]
                                                  ?.split(".")[0],
                                            });
                                          }

                                          setBillQualityDocuments([
                                            ...billQualityDocuments,
                                            { ...qualityDocObject, file },
                                          ]);
                                          setQualityDocObject({
                                            name: "",
                                          });
                                        }}
                                        accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>}


                            {billQualityDocuments?.length > 0 ? (
                              <>
                                <div className="address-bar">
                                  <div className="billing-form">
                                    <div className="address">
                                      {billQualityDocuments.map((item, i) => {
                                        return (
                                          <div
                                            className="singleAddress "
                                            key={i}
                                            style={{
                                              marginTop: "5px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              <div className="address">
                                                <div className="name">
                                                  Document Name : {item.name}
                                                </div>
                                                <div className="add flex items-center gap-x-2 ">
                                                  <span>File :</span>
                                                  {item.file?.filename ? (
                                                    <div>
                                                      <a
                                                        className="downloadables flex items-center gap-x-2"
                                                        href={
                                                          item.file?.name
                                                            ? URL.createObjectURL(
                                                              item.file
                                                            )
                                                            : (item.file
                                                              ?.originalname,
                                                              `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                                        }
                                                        download={
                                                          item.file?.filename
                                                        }
                                                        target="_blank"
                                                      >
                                                        <span>
                                                          {
                                                            item.file
                                                              ?.originalname
                                                          }
                                                        </span>
                                                        <DownloadIcon />
                                                      </a>
                                                    </div>
                                                  ) : (
                                                    <div className="flex items-center gap-x-2 ">
                                                      <a
                                                        className="text-primaryColor  flex items-center gap-x-2 "
                                                        href={
                                                          item.file?.name
                                                            ? URL.createObjectURL(
                                                              item.file
                                                            )
                                                            : (item.file
                                                              ?.originalname,
                                                              `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                                        }
                                                        download={
                                                          item.file?.filename
                                                        }
                                                        target="_blank"
                                                      >
                                                        {item.file?.name}
                                                        <DownloadIcon />
                                                      </a>
                                                      <div
                                                        onClick={() =>
                                                          handleQualityDocumentDelete(
                                                            i
                                                          )
                                                        }
                                                      >
                                                        <DeleteIcon />
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="buttons">
                                                <div
                                                  className="delete"
                                                  
                                                >
                                                  Delete
                                                </div>
                                              </div> */}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <>
                <button className="req-quote-btn" onClick={handleCreateBill}>
                  Send For Approval
                </button>
              </>
              <button
                className="req-quote-btn"
                onClick={closeCreateInvoiceModal}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

          <div className="intro-bar-rfq">
            <div className="int-left">
              <div
                className="left-item"
                style={{ marginRight: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <img src={backImg} height="15px" />
              </div>
              <div className="left-item">
                <p className="p-header">ORDER ID : {order?.pORefId}</p>
                <p className={`${order?.status?.replaceAll(" ", "_")}  flex items-center justify-center my-1`}>

                  {order?.status}{" "}
                </p>
              </div>
              <div className="left-item">
                <p className="p-header">REQUESTED DATE</p>
                <p>
                  {moment(order?.poApprovedDate || order?.createdAt).format(
                    "DD MMM YYYY"
                  )}
                </p>
              </div>
              <div className="left-item">
                <p className="p-header">ORDER VALUE</p>
                <p>
                  €{" "}
                  <CurrencyFormat
                    amount={Number(order?.totalAmount).toFixed(2)}
                  />
                </p>
              </div>
              <div className="left-item flex flex-col items-start gap-x-2">
                <span className="p-header flex">
                  <span className="mx-1">PSD</span>
                  <HoverInfo content="Promised Shipping Date(PSD) : If you require extension due to any unforeseen circumstance please get in touch with support team at info@dainsta.com" />
                </span>
                <p className="font-bold">
                  {order?.poAcceptanceDate ? (
                    <>
                      {moment(order?.poAcceptanceDate)
                        .add(order?.supplierRFQId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  ) : (
                    <>
                      {moment(Date.now())
                        .add(order?.supplierRFQId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  )}
                </p>
              </div>
              <div className="left-item flex flex-col items-start gap-x-2" >
                <span className="p-header">
                  <div className="flex gap-x-2 items-center">
                    <span className="flex">
                      <span className="mx-0.5">ESD</span>
                      <HoverInfo content="Expected Shipping Date. In case of delivery delay, click on edit icon on the right to change the expected shipping date." />
                    </span>
                    
                  </div>
                </span>
                <p className="font-bold flex items-center  gap-x-3 ">
                  {order?.expectedShippingDates?.length > 0 ? (
                    <>
                      {moment(
                        order?.expectedShippingDates.reduce(
                          (maxObj, currentObj) => {
                            if (currentObj.updatedDate > maxObj.updatedDate) {
                              return currentObj;
                            }
                            return maxObj;
                          }
                        ).updateValue
                      ).format("DD MMM YYYY")}
                    </>
                  ) : (
                    <>
                      {moment(order?.poAcceptanceDate)
                        .add(order?.supplierRFQId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  )}
                   {billsForPurchaseOrder?.length == 0 && (
                      <div  onClick={() => setShowExpectedDateModal(true)}>
                        <EditIcon additionalClass={'text-primaryColor !h-4 mt-[2px]'} />
                      </div>
                    )}
                </p>
               
              </div>
            </div>
            <div className="int-right">
              <div className="right-item">
                <button
                  className="white-btn"
                  onClick={handlePODownloadClick}
                  style={{ fontWeight: "500" }}
                >
                  {" "}
                  <DownloadIcon additionalClass={'!h-4'} />
                  &nbsp; Download PO
                </button>
              </div>
              <div className="right-item">
                <button
                  className="border bg-primaryColor rounded"
                  onClick={showDrawer}
                >
                  <ChatButton
                    color={"white"}
                    RefId={order?.pORefId}
                    showDrawer={showDrawer}
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-holder">
            <div className="md-container">
              <div className="common-bx">
                <div
                  className={
                    order?.status == "Awaiting PO Acceptance"
                      ? "process-bar-bx upload-req or-details-row"
                      : "process-bar-bx  upload-req green-line or-details-row"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={settingw} />
                  </span>
                  <div className="req-box">
                    <Accordion
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                      className="requirement-box"
                    >
                      <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <div className="accordion-title">
                          <div className="accordion-icon">
                            <span
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>
                                <h5>Order Details</h5>
                                <div className="cnc-box">
                                  <p>
                                    Order placed on{" "}
                                    {moment(
                                      order?.supplierRFQId?.createdAt
                                    ).format("DD MMM YYYY")}
                                  </p>
                                  <div className="cnc-box">
                                    {processType.map((val, i) => {
                                      if (
                                        val.id ==
                                        order?.supplierRFQId?.selectedProcess
                                      ) {
                                        return <p key={i}>{val.name}</p>;
                                      } else {
                                        return;
                                      }
                                    })}
                                  </div>
                                </div>
                              </span>
                              <div style={{ marginRight: "30px" }}>
                                <span
                                  className="text"
                                  style={{ color: "#858585" }}
                                >
                                  Project Name
                                </span>
                                <div className="name">
                                  {order?.supplierRFQId?.rfqId?.projectName ||
                                    "Not Found"}
                                </div>
                              </div>
                            </span>

                            <img
                              src={
                                expanded === "panel1"
                                  ? upArrowIcon
                                  : downArrowIcon
                              }
                              alt="arrowIcon"
                              style={{ height: "8px", marginRight: "10px" }}
                            />
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails >
                        {order?.supplierRFQId ? (
                          <div className="version-tabs " >
                            {order?.status == "Awaiting PO Acceptance" ? (
                              <>
                                <div
                                  style={{
                                    background: "#FFF5C4",
                                    padding: "20px 30px",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div>
                                    <h6>
                                      Quote accepted. Awaiting PO acceptance.
                                    </h6>
                                    <p>
                                      Please accept the PO to confirm the
                                      order?.
                                    </p>
                                  </div>
                                  <div className="flex justify-between gap-x-2 items-center">
                                    <button
                                      className="flex items-center justify-center gap-x-2  w-[180px] h-10 rounded"
                                      style={{
                                        color: "white",
                                        fontWeight: "500",
                                        backgroundColor: "#00c389",

                                      }}
                                      onClick={handleAcceptPOClick}
                                    >
                                      Accept PO
                                    </button>

                                    <button
                                      className=" flex items-center justify-center gap-x-2 bg-white w-[180px] h-10 text-primaryColor rounded"
                                      onClick={handlePODownloadClick}
                                      style={{
                                        fontWeight: "500",
                                      }}
                                    >
                                      <DownloadIcon additionalClass={'!h-4'} />
                                      &nbsp; Download PO
                                    </button>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="pro-bar">
                                <div className="pro-text">
                                  <div className="pro-bar-two">
                                    <div
                                      className="col"
                                    >
                                      <h6>ORDER ACCEPTED ON:</h6>
                                      <div className="desc-part">
                                        <p>
                                          {moment(
                                            order?.poAcceptanceDate
                                          ).format("DD MMM YYYY")}
                                        </p>
                                      </div>
                                    </div>

                                    <div
                                      className="col"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <h6>PO NUMBER :</h6>
                                      <div className="desc-part">
                                        <p>
                                          {order?.purchaseOrderNumber
                                            ? order?.purchaseOrderNumber
                                            : "NA"}
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="col"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <h6>PO Document</h6>
                                      <button
                                        className="white-btn"
                                        onClick={handlePODownloadClick}
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "12px",
                                        }}
                                      >
                                       <DownloadIcon additionalClass={'!h-4'}/>
                                        <span>Download PO</span> 
                                      </button>
                                    </div>
                                    <div
                                      className="col"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <h6>SHIPPING ADDRESS</h6>
                                      <div className="desc-part">
                                        <p>
                                          {order?.shippingAddress?.firstName
                                            ? order?.shippingAddress?.firstName
                                            : "" +
                                              " " +
                                              order?.shippingAddress?.lastName
                                              ? order?.shippingAddress?.lastName
                                              : ""}{" "}
                                        </p>
                                        <p>
                                          {order?.shippingAddress
                                            ?.addressLineOne
                                            ? order?.shippingAddress
                                              ?.addressLineOne
                                            : "" +
                                              " " +
                                              order?.shippingAddress
                                                ?.addressLineTwo
                                              ? order?.shippingAddress
                                                ?.addressLineTwo
                                              : ""}
                                        </p>
                                        <p>
                                          {order?.shippingAddress?.city
                                            ? order?.shippingAddress?.city
                                            : "" +
                                              ", " +
                                              order?.shippingAddress?.state
                                              ? order?.shippingAddress?.state
                                              : "" +
                                                ", " +
                                                order?.shippingAddress?.country
                                                ? order?.shippingAddress?.country
                                                : ""}
                                        </p>
                                        <p>
                                          {order?.shippingAddress?.postalCode
                                            ? order?.shippingAddress?.postalCode
                                            : ""}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <br />
                            <Tabs
                              id="controlled-tab-example"
                              activeKey={"final-order"}
                              className="mb-3 qoute-version-tabs"
                            >
                              <Tab eventKey="final-order" title={`Final Order`}>
                                <div
                                  className="version-tabs"
                                  style={{ overflowX: "auto" }}
                                >
                                  <table className="qoute-version-table">
                                    <thead>
                                      <tr className="heading-row">
                                        <th scope="col">Part Name</th>
                                        <th scope="col">Attachment 1</th>
                                        <th scope="col">Attachment 2</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Part Notes</th>
                                        <th scope="col">Notes</th>
                                        <th scope="col">Unit Price</th>
                                        <th scope="col">Qty</th>
                                        <th scope="col">Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {order?.supplierRFQId?.partsData?.length >
                                        0 &&
                                        order?.supplierRFQId.partsData.map(
                                          (item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td
                                                  style={{ minWidth: "80px" }}
                                                >
                                                  <p>
                                                    {item?.partName
                                                      ? item?.partName
                                                      : "Not found"}
                                                  </p>
                                                </td>
                                                <td
                                                // style={{
                                                //   wordWrap: "break-word",
                                                //   wordBreak: "break-all",
                                                //   whiteSpace: "normal",
                                                //   width: "120px",
                                                // }}
                                                >
                                                  <div
                                                    className="prd-thumb downloadables"
                                                    style={{
                                                      color: "dodgerblue",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "dodgerblue",
                                                      }}
                                                    >
                                                      {item.selectedPartFile ? (
                                                        <div className="inline-flex max-w-[200px] items-center justify-between">
                                                          <span className="inline-block truncate">
                                                            {item?.selectedPartFile?.originalname}
                                                          </span>
                                                          <span
                                                            className="inline-block cursor-pointer"
                                                            onClick={(e) => {
                                                              let url = `${process.env.REACT_APP_API_ENDPOINT}/${item?.selectedPartFile?.path}`;
                                                              download(item?.selectedPartFile?.originalname, url);
                                                            }}
                                                          >
                                                            <DownloadIcon additionalClass="h-4" />
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        <div className="inline-flex max-w-[200px] items-center">
                                                          <span>No File Uploaded</span>
                                                        </div>
                                                      )}
                                                    </p>
                                                  </div>
                                                </td>
                                                <td

                                                >
                                                  <div
                                                    className="prd-thumb downloadables"
                                                    style={{
                                                      color: "dodgerblue",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "dodgerblue",
                                                      }}
                                                    >
                                                      {item.selected3DPartFile ? (
                                                        <div div className="inline-flex  max-w-[200px] items-center justify-center">
                                                          <span
                                                            className="inline-block truncate"


                                                          > {
                                                              item
                                                                ?.selected3DPartFile
                                                                ?.originalname
                                                            }</span>

                                                          <span
                                                            className="inline-block cursor-pointer"
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={(e) => {
                                                              let url = `${process.env.REACT_APP_API_ENDPOINT}/${item.selected3DPartFile.path}`;
                                                              download(
                                                                item
                                                                  ?.selected3DPartFile
                                                                  ?.originalname,
                                                                url
                                                              );
                                                            }}
                                                          >
                                                            <DownloadIcon additionalClass={'h-4'} />
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        "No File Uploaded"
                                                      )}
                                                    </p>
                                                  </div>
                                                </td>
                                                <td
                                                  style={{ minWidth: "250px" }}
                                                >
                                                  {order?.supplierRFQId
                                                    .selectedProcess >= 3 ? (
                                                    <>{item?.description}</>
                                                  ) : (
                                                    <>
                                                      <ul
                                                        style={{
                                                          listStyle: "none",
                                                          padding: 0,
                                                          margin: 0,
                                                        }}
                                                      >
                                                        {item?.description}
                                                        {item?.materialType ? (
                                                          <li>
                                                            {item?.materialType}
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.subMaterial ? (
                                                          <li>
                                                            {item?.subMaterial}
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.surfaceFinish ? (
                                                          <li>
                                                            {
                                                              item?.surfaceFinish
                                                            }
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.surfaceTreatment ? (
                                                          <li>
                                                            {
                                                              item?.surfaceTreatment
                                                            }
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.tolerance ? (
                                                          <li>
                                                            {item?.tolerance}
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.partMarking ? (
                                                          <li>
                                                            {item?.partMarking}
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        {item?.noOfThread ? (
                                                          <li>
                                                            {item?.noOfThread}
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </ul>
                                                    </>
                                                  )}
                                                </td>
                                                <td>
                                                  <p className="amt">
                                                    {item?.partNotes}
                                                  </p>
                                                </td>
                                                <td>
                                                  <p className="amt">
                                                    {item?.notes}
                                                  </p>
                                                </td>
                                                <td style={{ width: "80px" }}>
                                                  <p className="amt">
                                                    {" "}
                                                    €{" "}
                                                    <CurrencyFormat
                                                      amount={Number(
                                                        item?.price
                                                      ).toFixed(2)}
                                                    />
                                                  </p>
                                                </td>
                                                <td>
                                                  <p className="amt">
                                                    {item?.qty}
                                                  </p>{" "}
                                                </td>
                                                <td>
                                                  {" "}
                                                  <div
                                                    className="amt"
                                                    style={{ width: "60px" }}
                                                  >
                                                    <p className="un-fld">
                                                      €{" "}
                                                      <CurrencyFormat
                                                        amount={Number(
                                                          item.qty * item.price
                                                        ).toFixed(2)}
                                                      />
                                                    </p>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}

                                      {order.adjustmentValue != 0 ? (
                                        <>
                                          <tr className="heading-row">
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col">Adjustments</td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col">
                                              <p className="un-fld">
                                                €{" "}
                                                <CurrencyFormat
                                                  amount={Number(
                                                    order.adjustmentValue
                                                  ).toFixed(2)}
                                                />
                                              </p>
                                            </td>
                                          </tr>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Tab>
                            </Tabs>
                          </div>
                        ) : (
                          <>
                            <p>Loading</p>
                          </>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>

                {/* <div
                  className={
                    order?.status == "Awaiting PO Acceptance"
                      ? "process-bar-bx upload-req or-details-row"
                      : "process-bar-bx  upload-req green-line or-details-row"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={orderIcon} />
                  </span>
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChange("panel2")}
                  >
                    <AccordionSummary
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                    >
                      <div style={{ marginTop: "-10px" }}>
                        <div className="accordion-icon">
                          <h5>Order Details</h5>
                          <img
                            src={
                              expanded === "panel2"
                                ? upArrowIcon
                                : downArrowIcon
                            }
                            alt="arrowIcon"
                            style={{ height: "8px", marginRight: "10px" }}
                          />
                        </div>
                        <div className="orderAndPayment">
                          <p>
                            Order placed on{" "}
                            {moment(order?.createdAt).format("DD MMM YYYY")}
                          </p>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {order?.status == "Awaiting PO Acceptance" ? (
                        <>
                          <div
                            style={{
                              background: "#FFF5C4",
                              padding: "20px 30px",
                              borderRadius: "5px",
                              fontSize: "14px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <h6>Quote accepted. Awaiting PO acceptance.</h6>
                              <p>Please accept the PO to confirm the order?.</p>
                            </div>
                            <div>
                              <button
                                className="chatButton"
                                style={{
                                  color: "white",
                                  fontWeight: "500",
                                  backgroundColor: "#00c389",
                                  width: "150px",
                                  marginBottom: "5px",
                                }}
                                onClick={handleAcceptPOClick}
                              >
                                Accept PO
                              </button>

                              <button
                                className="white-btn"
                                onClick={handlePODownloadClick}
                                style={{
                                  fontWeight: "500",
                                  marginRight: "0px",
                                  width: "150px",
                                }}
                              >
                                <img src={downloadImage} height="12" />
                                &nbsp; Download PO
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="pro-bar">
                          <div className="pro-text">
                            <div className="pro-bar-one"></div>
                            <div className="pro-bar-two">
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>ORDER ACCEPTED ON:</h6>
                                <div className="desc-part">
                                  <p>
                                    {moment(order?.poAcceptanceDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>

                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>PO NUMBER :</h6>
                                <div className="desc-part">
                                  <p>
                                    {order?.purchaseOrderNumber
                                      ? order?.purchaseOrderNumber
                                      : "NA"}
                                  </p>
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>PO Document</h6>
                                <button
                                  className="white-btn"
                                  onClick={handlePODownloadClick}
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                  }}
                                >
                                  {" "}
                                  <img
                                    src={downloadImage}
                                    alt="download-img"
                                    height="12"
                                  />
                                  &nbsp; Download PO
                                </button>
                              </div>
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>SHIPPING ADDRESS</h6>
                                <div className="desc-part">
                                  <p>
                                    {order?.shippingAddress?.firstName
                                      ? order?.shippingAddress?.firstName
                                      : "" +
                                        " " +
                                        order?.shippingAddress?.lastName
                                        ? order?.shippingAddress?.lastName
                                        : ""}{" "}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.addressLineOne
                                      ? order?.shippingAddress?.addressLineOne
                                      : "" +
                                        " " +
                                        order?.shippingAddress?.addressLineTwo
                                        ? order?.shippingAddress?.addressLineTwo
                                        : ""}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.city
                                      ? order?.shippingAddress?.city
                                      : "" +
                                        ", " +
                                        order?.shippingAddress?.state
                                        ? order?.shippingAddress?.state
                                        : "" +
                                          ", " +
                                          order?.shippingAddress?.country
                                          ? order?.shippingAddress?.country
                                          : ""}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.postalCode
                                      ? order?.shippingAddress?.postalCode
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </div> */}

                {order?.status == "Awaiting PO Acceptance" ? (
                  <></>
                ) : (
                  <>
                    {order?.qrCodeDrawingFile?.originalname ? (
                      <>
                        <div
                          className={
                            order?.qrCodeDrawingFile?.originalname
                              ? "process-bar-bx upload-req or-details-row grey-line"
                              : "process-bar-bx upload-req or-details-row green-line"
                          }
                        >
                          <span
                            className={
                              order?.qrCodeDrawingFile.originalname
                                ? "process-ico green-fill"
                                : "process-ico grey-fill"
                            }
                          >
                            <img src={qrCodeIcon} />
                          </span>
                          <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChange("panel3")}
                          >
                            <AccordionSummary
                              aria-controls="panel3bh-content"
                              id="panel3bh-header"
                            >
                              <div style={{ marginTop: "-10px" }}>
                                <div className="accordion-icon">
                                  <h5>QR Code</h5>
                                  <img
                                    src={
                                      expanded === "panel3"
                                        ? upArrowIcon
                                        : downArrowIcon
                                    }
                                    alt="arrowIcon"
                                    style={{
                                      height: "8px",
                                      marginRight: "10px",
                                    }}
                                  />
                                </div>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="pro-bar">
                                <div className="pro-text">
                                  <div className="pro-bar-one"></div>
                                  <div className="pro-bar-two">
                                    <div
                                      className="col"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <div>
                                        <p>
                                          The customer has made a request to
                                          have QR codes etched onto the parts.
                                        </p>
                                      </div>
                                      <br />
                                      <div>
                                        <button
                                          className="white-btn"
                                          onClick={() =>
                                            download(
                                              order?.qrCodeDrawingFile
                                                .originalname,
                                              `${process.env.REACT_APP_API_ENDPOINT}/` +
                                              order?.qrCodeDrawingFile.path
                                            )
                                          }
                                          style={{
                                            fontWeight: "500",
                                            fontSize: "13px",
                                          }}
                                        >
                                          <img
                                            src={downloadImage}
                                            alt="download-img"
                                            height="13"
                                          />
                                          &nbsp; Download QR Drawing File
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div
                      className={
                        order?.status == "Order Processing"
                          ? "process-bar-bx upload-req or-details-row"
                          : "process-bar-bx upload-req or-details-row"
                      }
                    >
                      <span
                        className={
                          billsForPurchaseOrder.length > 0
                            ? "process-ico green-fill"
                            : "process-ico grey-fill"
                        }
                      >
                        <img src={consignmentPhotoIcon} />
                      </span>
                      <Accordion
                        expanded={expanded === "panel4"}
                        onChange={handleChange("panel4")}
                      >
                        <AccordionSummary
                          aria-controls="panel4bh-content"
                          id="panel4bh-header"
                        >
                          <div style={{ marginTop: "-10px" }}>
                            <div className="accordion-title">
                              <div className="accordion-icon">
                                <h5>Invoicing</h5>
                                <img
                                  src={
                                    expanded === "panel4"
                                      ? upArrowIcon
                                      : downArrowIcon
                                  }
                                  alt="arrowIcon"
                                  style={{ height: "8px", marginRight: "10px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="pro-bar">
                            <div
                              style={{
                                width: "100%",
                                textAlign: "right",
                                marginBottom: "10px",
                              }}
                            >
                              <button
                                className="white-btn"
                                onClick={handleCreateNewInvoiceClick}
                              >
                                <DownloadIcon additionalClass={'!h-4'} />

                                <span className="text-primaryColor mx-2 font-medium">Create New Invoice</span>
                              </button>
                            </div>
                            <div className="pro-bar-two">
                              <div className="table-container">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Invoice Ref</th>
                                      <th>Invoice Number</th>
                                      <th>Amount</th>
                                      <th>Status</th>
                                      <th>Sent Date</th>
                                      <th>Shipping Date</th>
                                      <th>Due Date</th>
                                      {/* <th>Details</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {billsForPurchaseOrder.length > 0 ? (
                                      billsForPurchaseOrder?.map(
                                        (item, index) => {
                                          return (
                                            <tr key={index}>
                                              <td
                                                onClick={() =>
                                                  handleViewDetailsClick(item)
                                                }>
                                                <Link className="underline text-primaryColor">{item.billNumber}</Link>
                                              </td>
                                              <td>{item.supplierBillNumber}</td>
                                              <td>
                                                {currencyFormatter(
                                                  item.billTotalAmount
                                                )}
                                              </td>
                                              <td>{item.status.replace(/_/g, ' ').replace(/\b\w/, (c) => c.toUpperCase())}</td>

                                              <td>
                                                {moment(item.createdAt).format(
                                                  "DD MMM YYYY"
                                                )}
                                              </td>

                                              <td>
                                                {item.shippedDate?moment(
                                                  item.shippedDate
                                                ).format("DD MMM YYYY"):"NA"}
                                              </td>
                                              <td>
                                                {item.dueDate
                                                  ? moment(
                                                    item.shippedDate
                                                  ).format("DD MMM YYYY")
                                                  : "NA"}
                                              </td>

                                            </tr>
                                          );
                                        }
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </tbody>
                                </table>
                                {billsForPurchaseOrder.length == 0 ? (
                                  <>
                                    <p
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {" "}
                                      No Invoice is created for purchase order.
                                      Please create invoice using "Create New
                                      Invoice" button.
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="dashboard-holder">
            <div className="sm-container">
              <div className="dashboard-option">
                <div className="dash-left">
                  <div className="ds-heading">
                    <Link to="/dashboard">
                      <p className="req-quote-btn">Go To DashBoard </p>
                    </Link>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <h2>Order information is not available</h2>
                  <br />
                  <p>Your dont have access to this order details.</p>
                </div>
              </div>
              {/* <div className="privacy-text">
                <strong>Privacy:</strong> Dainsta 3D secures all uploaded files,
                protecting your intellectual property. If you can’t upload your
                files at the moment, use our sample part to try out our instant
                quoting and DfM tools or contact us on{" "}
                <a href="mailto: info@dainsta.com">info@dainsta.com</a> to sign
                an NDA.
              </div> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default OrderDetails;
